export default "__VITE_ASSET__ab9e1c1d__"